module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-chart-legend",
    class: ( _obj = {}, _obj['c-chart-legend--' + _vm.columns] = true, _obj ),
    style: ({
      width: _vm.legendWidth + '%',
      marginTop: _vm.marginTop + 'px',
      marginBottom: _vm.marginBottom + 'px'
    })
  }, [_c('div', {
    staticClass: "u-d-flex",
    class: {
      'u-flex-wrap': _vm.theCurrentWidth <= 400
    }
  }, [_c('div', {
    staticClass: "c-chart-legend__column"
  }, [_c('div', {
    staticClass: "u-d-inline-block"
  }, _vm._l((_vm.columnOne), function(value, index) {
    return _c('div', {
      staticClass: "u-d-flex u-text-left"
    }, [_c('div', {
      staticClass: "c-chart-legend__item",
      style: ({
        background: _vm.columnOneColours[index]
      })
    }), _vm._v("\n                    " + _vm._s(_vm.columnOne[index]) + "\n                ")])
  }), 0)]), _vm._v(" "), (_vm.columns === 2 || _vm.columns === 3) ? _c('div', {
    staticClass: "c-chart-legend__column"
  }, [_c('div', {
    staticClass: "u-d-inline-block"
  }, _vm._l((_vm.columnTwo), function(value, index) {
    return _c('div', {
      staticClass: "u-d-flex u-text-left"
    }, [_c('div', {
      staticClass: "c-chart-legend__item",
      style: ({
        background: _vm.columnTwoColours[index]
      })
    }), _vm._v("\n                    " + _vm._s(_vm.columnTwo[index]) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.columns === 3) ? _c('div', {
    staticClass: "c-chart-legend__column"
  }, [_c('div', {
    staticClass: "u-d-inline-block"
  }, _vm._l((_vm.columnThree), function(value, index) {
    return _c('div', {
      staticClass: "u-d-flex u-text-left"
    }, [_c('div', {
      staticClass: "c-chart-legend__item",
      style: ({
        background: _vm.columnThreeColours[index]
      })
    }), _vm._v("\n                    " + _vm._s(_vm.columnThree[index]) + "\n                ")])
  }), 0)]) : _vm._e()])])
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96f7c0c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chart/Legend.vue
// module id = 1777
// module chunks = 0